import { useCallback } from 'react';

const validate = (cred) => {
  const errors = {};

  if (!cred?.data?.npi?.npi_number) {
    errors.npi_number = 'NPI number is required';
  }

  return errors;
};

const hasFieldChanged = (current, original) =>
  (current?.data?.npi?.npi_number ?? '') !== (original?.data?.npi?.npi_number ?? '');

export const useCredentialNpi = () => {
  const getErrors = useCallback((current, original) => {
    const allErrors = validate(current);
    const visibleErrors = {};
    Object.entries(allErrors).forEach(([field, message]) => {
      if (hasFieldChanged(current, original)) {
        visibleErrors[field] = message;
      }
    });
    return visibleErrors;
  }, []);

  const validateAll = useCallback((credentials) => {
    const allErrors = {};

    credentials.forEach((cred) => {
      const credErrors = validate(cred);
      if (Object.keys(credErrors).length > 0) {
        allErrors[cred.id || cred.credential] = credErrors;
      }
    });

    return allErrors;
  }, []);

  return { getErrors, validateAll };
};
